import { Typography, Grid, Box } from "@mui/material";
import React from "react";
import { AnalyticsContext } from "../context/analyticsContext";
import { IAppointment } from "../interface/iAppointment";
import AppointmentListFilter from "./appointmentListFilter";
import removeSeconds from "../../../../functions/removeSeconds";
import transformDateToDe from "../../../../functions/transformDateToDe";
import AppointmentListHead from "./appointmentListHead";
import CustomPagination from "../../../../components/pagination/customPagination";
import IPagination from "../../../../components/pagination/interface/iPagination";

const AppointmentList = () => {
  const {
    getFilteredAppointmentList,
    paginationSettings,
    setPaginationSettings,
  }: {
    getFilteredAppointmentList: () => IAppointment[];
    paginationSettings: IPagination;
    setPaginationSettings: React.Dispatch<React.SetStateAction<IPagination>>;
  } = React.useContext(AnalyticsContext);

  const getBackgroundColor = (appointment: IAppointment): string => {
    // active
    if (appointment.status === "G" && new Date(appointment.date) >= new Date())
      return "success.light";

    // completed
    if (appointment.status === "G" && new Date(appointment.date) < new Date())
      return "secondary.light";

    // missed
    if (appointment.status === "V") return "error.light";

    // cancelled
    if (appointment.status === "K") return "warning.light";

    // free
    if (appointment.status === "F") return "info.light";

    return "#eee"; // default white
  };

  const filteredList = getFilteredAppointmentList();
  const paginated = filteredList.slice(
    (paginationSettings.page - 1) * paginationSettings.rowsPerPage,
    paginationSettings.page * paginationSettings.rowsPerPage,
  );

  return (
    <Box sx={{ mt: 4 }}>
      <AppointmentListFilter />
      <AppointmentListHead />

      {paginated.map((appointment: IAppointment) => (
        <Grid
          container
          columnSpacing={0}
          key={appointment.id}
          sx={{
            mb: 1,
            backgroundColor: getBackgroundColor(appointment),
            borderRadius: 2,
            px: 2,
            py: 1,
          }}
        >
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="body2" color="initial">
              {transformDateToDe(appointment.date)}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="body2" color="initial">
              {removeSeconds(appointment.startTime)} -{" "}
              {removeSeconds(appointment.endTime)}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="body2" color="initial">
              {appointment.lastName !== null &&
                appointment.firstName !== null &&
                `${appointment.lastName}, ${appointment.firstName}`}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Typography
              variant="body2"
              color="initial"
              sx={{
                wordBreak: "break-all",
                overflowWrap: "break-word",
                whiteSpace: "normal",
              }}
            >
              {appointment.phone}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="body2"
              color="initial"
              sx={{
                wordBreak: "break-all",
                overflowWrap: "break-word",
                whiteSpace: "normal",
              }}
            >
              {appointment.email}
            </Typography>
          </Grid>
        </Grid>
      ))}

      <CustomPagination
        items={filteredList}
        paginationSettings={paginationSettings}
        setPaginationSettings={setPaginationSettings}
      />
    </Box>
  );
};

export default AppointmentList;
